import React from "react";
import VariableForm from "./VariableForm";

export type UpdateVariableProps = Pick<
  React.ComponentProps<typeof VariableForm>,
  "variable" | "switchToVariableListHandler"
>;

/** Thin mode wrapper around the shared VariableForm (SCRUM-899). */
const UpdateVariable = (props: UpdateVariableProps) => (
  <VariableForm
    mode="update"
    variable={props.variable}
    switchToVariableListHandler={props.switchToVariableListHandler}
  />
);

export default UpdateVariable;
